import React, { FC } from 'react';
import { useField, UseFieldConfig } from 'react-final-form';

import Dropdown, { IProps as IDropdownProps } from '../../Fields/Dropdown';

type IProps = {
  name: string;
  useFieldConfig?: UseFieldConfig<string>;
} & IDropdownProps;

const FormDropdown: FC<IProps> = ({ name, useFieldConfig, description, ...props }) => {
  const {
    input,
    meta: { touched, error }
  } = useField(name, useFieldConfig);

  // Адаптер под mts-ds
  input.onMtsChange = input.onChange;
  input.onMtsFocus = input.onFocus;
  input.onMtsBlur = input.onBlur;

  const message = touched && error;

  const isError = Boolean(message);

  // Ошибка валидации важнее вспомогательного текста: показываем её, когда поле невалидно,
  // иначе — description, переданный вызывающим кодом (helper text).
  return <Dropdown description={isError ? message : description} valid={!isError} {...input} {...props} />;
};

export default FormDropdown;
